/*
  Market gate — shown once, on a first visit.

  Answering submits Shopify's own localization form, so the redirect to the
  right market is Shopify's job. Dismissing counts as answered: a visitor who
  closes it has told us they do not want to be asked.
*/
(() => {
  const SEEN = 'alepu:market-gate';

  const seen = () => {
    try {
      return localStorage.getItem(SEEN) === '1';
    } catch {
      // Private browsing and blocked site data both throw. Treat an
      // unreadable store as "already asked" — a dialog that cannot remember
      // being dismissed would return on every page load.
      return true;
    }
  };

  const remember = () => {
    try {
      localStorage.setItem(SEEN, '1');
    } catch {
      /* nothing to do — the visitor still gets their answer applied */
    }
  };

  const bind = (root) => {
    const gate = root.querySelector('[data-market-gate]');
    if (!gate || gate.dataset.bound === '1') return;
    gate.dataset.bound = '1';

    // In the Theme Editor the merchant needs to see it to style it, so the
    // once-only rule is skipped there.
    if (!window.Shopify?.designMode && seen()) return;

    const panel = gate.querySelector('[data-gate-panel]');
    const form = gate.querySelector('form');
    let restoreFocus = null;

    const close = () => {
      remember();
      gate.classList.remove('is-open');
      gate.hidden = true;
      document.removeEventListener('keydown', onKeydown);
      restoreFocus?.focus();
    };

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;

      const focusable = panel.querySelectorAll('button, select, [href], input');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    gate.querySelectorAll('[data-gate-dismiss]').forEach((el) => el.addEventListener('click', close));
    // Submitting navigates away, so the flag has to be set before it does.
    form?.addEventListener('submit', remember);
    document.addEventListener('keydown', onKeydown);

    restoreFocus = document.activeElement;
    gate.hidden = false;
    requestAnimationFrame(() => gate.classList.add('is-open'));
    gate.querySelector('select')?.focus();
  };

  document.addEventListener('DOMContentLoaded', () => bind(document));

  // A Theme Editor reload replaces one section's markup; rebinding the whole
  // document would re-open a gate the visitor already closed.
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
